import $ from 'jquery';

export default class NavTrigger {
  constructor(options = {}) {
    this.$el = $(options.el); // Target element
    this.$document = $(document);

    this.namespace = options.namespace;
    this.trigger = options.trigger;
    this.onShow = options.onShow;
    this.onHide = options.onHide;
    this.$overlay = $('.site-navigation-overlay');

    this.isHovering = false;
    this.isTouching = false;
    this.isLocked = false;

    this.selector = `.site-navigation .navmenu-depth-1 > .navmenu-id-${this.trigger}`;

    this.events = [
      // Show/hide target when touched
      this.$document.on(`touchend.${this.namespace}`, this.selector, event => {
        event.preventDefault();
        this.toggle();
      }),

      // Show/hide target when hovering over the navigation trigger
      this.$document.on(`mouseenter.${this.namespace}`, this.selector, event => this.show()),
      this.$document.on(`mouseleave.${this.namespace}`, this.selector, event => this.hide()),

      this.$document.on(`focus.${this.namespace}`, this.selector, event => {
        this.show();
      }),
      this.$document.on(`blur.${this.namespace}`, this.selector, event => {
        this.hide();
      }),

      // Keep track of hovering state
      this.$el.on(`mouseenter.${this.namespace}`, event => {
        this.isHovering = !this.isTouching;
        this.isTouching = false;
      }),
      this.$el.on(`touchstart.${this.namespace}`, event => {
        this.isTouching = true;
      }),
      this.$el.on(`mouseleave.${this.namespace}`, event => {
        this.isHovering = false;
        this.hide();
      }),
    ];

    this.addTrigger();
  }

  unload() {
    // Reset state
    this.isHovering = false;
    this.isLocked = false;
    this.hide();

    // Unbind events
    this.events.forEach(event => event.off(`.${this.namespace}`));

    // Remove elements
    this.removeTriggers();
  }

  lock() {
    this.isLocked = true;
    this.show(true);
  }

  unlock() {
    this.isLocked = false;
    this.hide();
  }

  toggle() {
    if (this.$el.revealer('isVisible')) {
      this.hide();
    } else {
      this.show();
    }
  }

  /**
   * Show the target.
   *
   * @param {boolean} force
   *        If true, skip animations.
   */
  show(force) {
    this.$el.revealer('show', force).one('revealer-animating', () => {
      this.addShim();
      if (this.onShow) this.onShow();
    });
  }

  /**
   * Hide the target.
   *
   * Since the meganav element is not a child of the trigger element, we wait a
   * few milliseconds to allow time for the mouse to move between elements.
   */
  hide() {
    if (this.isLocked) {
      return;
    }

    this.hideOverlay();

    setTimeout(() => {
      if (this.isHovering) return;

      this.removeShim();

      this.$el.revealer('hide').one('revealer-hide', () => {
        if (this.onHide) this.onHide();
      });
    }, 10);
  }

  showOverlay() {
    this.$overlay.show();
  }

  hideOverlay() {
    this.$overlay.hide();
  }

  /**
   * Marks a specific navigation item as a trigger. Hovering over
   * that item should cause the target to show.
   */
  addTrigger() {
    const $trigger = $(this.selector);
    if (!$trigger.length) return;

    // Mark element as a trigger
    $trigger.attr('data-navmenu-trigger', this.namespace);

    // Disable regular dropdowns
    $trigger.attr('data-navmenu-ignore', true);
  }

  removeTriggers() {
    $(`[data-navmenu-trigger="${this.namespace}"]`).each((index, el) => {
      const $trigger = $(el);
      $trigger.removeAttr('data-navmenu-trigger');
      $trigger.removeData('navmenu-ignore');
    });
  }

  /**
   * Add shim element.
   *
   * +---------+
   * | TRIGGER |
   * +---------+
   * | SHIM    |  <- Add shim to allow the mouse to travel between the trigger
   * +---------+     and target elements without hiding the target
   * | TARGET  |
   * +---------+
   */
  addShim() {
    const $trigger = $(this.selector);
    if (!$trigger.length) return;


    // Calculate shim size
    const padding = 30;
    const height = this.$el.offset().top - ($trigger.offset().top + $trigger.outerHeight());
    const width = $trigger.outerWidth() + padding * 2;

    // Create shim element
    const $shim = $('<div>', {
      class: 'navtrigger-shim',
      css: {
        position: 'absolute',
        top: '100%',
        left: padding * -1,
        width,
        height,
      },
    });

    $trigger.append($shim);
  }

  /**
   * Remove shim element.
   */
  removeShim() {
    const $trigger = $(this.selector);
    $trigger.find('.navtrigger-shim').remove();
  }
}
